import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { lenisScrollToTop } from '../hooks/useLenis';

export const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        lenisScrollToTop();
    }, [pathname]);

    return null;
};
